var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "major" }, [
    _c("div", { staticClass: "major-header" }, [
      _c("i", {
        staticClass: "iconfont icon-xiangyou",
        class: [_vm.isDirection ? "" : "mirrorRotateLevel"],
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.goBack.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s("status"))])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "major-main" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "van-cell-group",
          _vm._l(_vm.items, function(item, index) {
            return _c(
              "div",
              { key: index },
              [
                item.isCell
                  ? _c("van-cell", { staticClass: "major-main-cell" }, [
                      _c(
                        "div",
                        {
                          staticClass: "major-main-cell-title",
                          attrs: { slot: "title" },
                          slot: "title"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.text) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "major-main-cell-label",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.detailDatas[item.field]) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "cell-copy copy-icon",
                          attrs: { slot: "extra" },
                          slot: "extra"
                        },
                        [
                          _c("i", {
                            staticClass: "copy iconfont icon-fuzhi",
                            attrs: {
                              "data-clipboard-text":
                                "https://t.me/SuperExOfficial"
                            },
                            on: { click: _vm.handleCopy }
                          })
                        ]
                      )
                    ])
                  : item.isGrid
                  ? _c("van-cell", { staticClass: "major-main-grid" }, [
                      _c(
                        "div",
                        {
                          staticClass: "major-main-grid-title",
                          attrs: { slot: "title" },
                          slot: "title"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.text1) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "major-main-grid-label",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "major-main-grid-label-text" },
                            [_vm._v(_vm._s(_vm.detailDatas[item.field1]))]
                          ),
                          _vm._v(" "),
                          item.isCopy
                            ? _c("span", { staticClass: "copy-icon" }, [
                                _c("i", {
                                  staticClass: "copy iconfont icon-fuzhi",
                                  attrs: {
                                    "data-clipboard-text":
                                      "https://t.me/SuperExOfficial"
                                  },
                                  on: { click: _vm.handleCopy }
                                })
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "grid-right",
                          attrs: { slot: "default" },
                          slot: "default"
                        },
                        [
                          _c("div", { staticClass: "grid-right-title" }, [
                            _vm._v(_vm._s(item.text2))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "grid-right-label" }, [
                            _vm._v(_vm._s(_vm.detailDatas[item.field2]))
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          }),
          0
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "major-main-title" }, [
      _c("span", { staticClass: "amount" }, [_vm._v("+ 1,000,000,000")]),
      _c("span", [_vm._v("sats")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d17cf94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d17cf94","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/InscriptionArea/tokenDetails.vue
// module id = rBfz
// module chunks = 0